export default __webpack_public_path__ + "static/media/3-publica.adc173cc.svg";